import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const ResponsiveNavMenuContainer = styled.div<{
  isMenuOpen: boolean;
  isHidden: boolean;
}>`
  width: ${(props) => (props.isMenuOpen ? '200px' : '80px')};
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(
    90deg,
    rgba(230, 230, 230, 1) 0%,
    rgba(255, 255, 255, 1) 100%
  );
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  box-shadow: 2px 0px 5px 0px rgba(50, 50, 50, 0.1);
  position: absolute;
  transition: width 0.5s;
  transition-timing-function: cubic-bezier(0, 0.5, 0, 1);

  &:hover {
    box-shadow: 4px 0px 4px -2px rgba(80, 185, 155, 0.5);
  }

  @media screen and (min-width: 0px) and (max-width: 480px) {
    ${(props) => props.isHidden && 'display: none;'}
    position: relative;
    width: 100%;
    height: 100px;
    flex-direction: row;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(230, 230, 230, 1) 100%
    );
    border-bottom-left-radius: 0px;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    box-shadow: 2px 0px 11px 1px rgba(50, 50, 50, 0.2);

    &:hover {
      box-shadow: 2px 0px 11px 1px rgba(50, 50, 50, 0.2);
    }
  }
`;

export const ArrowButton = styled.button`
  display: none;
  align-items: center;
  justify-content: center;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  border: 1.5px solid ${(props) => props.theme.newPalette.turquoise.T300};
  background-color: ${(props) => props.theme.newPalette.neutral.N100};
  position: absolute;
  right: -10px;
  top: 30px;
  padding: 0;
  cursor: pointer;
  outline: none;
  box-shadow:
    rgba(9, 30, 66, 0.08) 0px 0px 0px 1px,
    rgba(9, 30, 66, 0.08) 0px 2px 4px 1px;

  &:hover {
    background-color: ${(props) => props.theme.newPalette.turquoise.T200};
  }

  ${ResponsiveNavMenuContainer}:hover & {
    display: flex;
  }

  @media screen and (min-width: 0px) and (max-width: 480px) {
    display: none;

    ${ResponsiveNavMenuContainer}:hover & {
      display: none;
    }
  }
`;

export const ArrowImage = styled.img<{
  isMenuOpen: boolean;
}>`
  height: 10px;
  margin: ${(props) => (props.isMenuOpen ? '0 2px 0 0' : '0 0 0 3px')};
`;

export const ResponsiveNavList = styled.li`
  list-style: none;
  display: flex;
  flex-direction: column;
  margin-top: 10px;

  @media screen and (min-width: 0px) and (max-width: 480px) {
    flex-direction: row;
    width: 100%;
    justify-content: space-around;
    margin: 0;
  }
`;

export const ResponsiveNavListItem = styled.ul`
  padding-left: 0px;
`;

export const ResponsiveNavLink = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
`;

export const ResponsiveNavLinkText = styled.p<{
  selectedOption: boolean;
  isMenuOpen: boolean;
}>`
  color: ${(props) =>
    props.selectedOption
      ? props.theme.newPalette.turquoise.T300
      : props.theme.newPalette.neutral.N800};
  font-weight: ${(props) => (props.selectedOption ? '500' : '400')};
  display: ${(props) => (props.isMenuOpen ? 'inherit' : 'none')};
  font-size: 13px;
  margin: 0px 0 0 12px;

  ${ResponsiveNavLink}:hover & {
    color: ${(props) => props.theme.newPalette.turquoise.T300};
  }

  @media screen and (min-width: 0px) and (max-width: 480px) {
    display: none;
  }
`;

export const ResponsiveNavLinkSvg = styled.div<{
  messagesImage: boolean;
}>`
  height: 31px;

  & svg {
    width: ${(props) => (props.messagesImage ? '34px' : '31px')};
    margin-right: ${(props) => (props.messagesImage ? '-4px' : '0')};
  }

  ${ResponsiveNavLink}:hover & svg path {
    stroke: ${(props) => props.theme.newPalette.turquoise.T300};
  }

  ${ResponsiveNavLink}:hover & svg g#about-vault {
    stroke: ${(props) => props.theme.newPalette.turquoise.T300};
  }

  @media screen and (min-width: 0px) and (max-width: 480px) {
    & svg {
      width: ${(props) => (props.messagesImage ? '40px' : '35px')};
      height: ${(props) => (props.messagesImage ? '37px' : '33px')};
    }
  }
`;
